import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../../components/CheckoutForm";

export default function StripeForm(props) {
  const decodedString = atob(decodeURIComponent(props.token));
  const searchParams = new URLSearchParams(decodedString);
  const secureID = searchParams.get("secureID");
  const publicKey = searchParams.get("authToken");
  const stripePromise = loadStripe(publicKey);
  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret: secureID,
    appearance,
  };
  return (
    <Elements options={options} stripe={stripePromise}>
      <CheckoutForm props={props} />
    </Elements>
  );
}
